import { getterTree, mutationTree } from 'typed-vuex'

export const state = () => ({
  searchQuery: ''
})

interface ScholarshipsInCategory {
  [key: string]: { title: string; amount: number; }
}

export const getters = getterTree(state, {
  tabCategoriesList(state, getters, rootState, rootGetters) {
    return rootGetters['tabList/tabList'].reduce((acc: ScholarshipsInCategory, scholarship: Scholarship.General) => {
      const categories = scholarship.categories

      if (!categories || !categories.length) { return acc }

      categories.forEach((category) => {
        if (acc[category.id]) {
          acc[category.id].amount += 1
          return
        }

        acc[category.id] = {
          title: category.title,
          amount: 1
        }
      })

      return acc
    }, {})
  },

  categoriesList(state, getters, rootState) {
    if (!state.searchQuery) { return getters.tabCategoriesList }

    const searchQuery = state.searchQuery.trim()
    const list = getters.tabCategoriesList as ScholarshipsInCategory
    const result = {} as ScholarshipsInCategory

    for (const id in list) {
      const title = list[id].title
      if (title.toLowerCase().includes(searchQuery)) {
        result[id] = list[id]
      }
    }

    return result
  }
})

export const mutations = mutationTree(state, {
  setSearchQuery(state, { searchQuery }) {
    state.searchQuery = searchQuery
  }
})
